export var useAddressForm = function (_a) {
    var addressData = _a.addressData, setDataFormBusiness = _a.setDataFormBusiness;
    var handleSameAddress = function (checked, data) {
        if (data === "sameAddress") {
            if (checked) {
                setDataFormBusiness(function (prev) {
                    var _a, _b, _c, _d;
                    return ({
                        Province: (_a = addressData === null || addressData === void 0 ? void 0 : addressData.providence) !== null && _a !== void 0 ? _a : "",
                        Town: (_b = addressData === null || addressData === void 0 ? void 0 : addressData.town) !== null && _b !== void 0 ? _b : "",
                        Sector: (_c = addressData === null || addressData === void 0 ? void 0 : addressData.sector) !== null && _c !== void 0 ? _c : "",
                        propertyAddress: (_d = addressData === null || addressData === void 0 ? void 0 : addressData.address) !== null && _d !== void 0 ? _d : "",
                    });
                });
            }
            else {
                setDataFormBusiness(function (prev) { return ({
                    Province: "",
                    Town: "",
                    Sector: "",
                    propertyAddress: "",
                }); });
            }
        }
    };
    return { handleSameAddress: handleSameAddress };
};
